// extracted by mini-css-extract-plugin
export default {"accordionGroup":"AccordionGroup-module__accordionGroup-FIK_lJ"};